import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default, { useState } from 'react';
import styles from './06e82d99deafe3745882c79d5544d22b6e46613c55f2fecd2f6394a180146c1f.cfe-internal.js';
import '../Tooltip/ca664ad530b3b769c7b76cb94c664b585fc864e665376d1d61d1c56f079a099a.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useMounted from '../../hooks/useMounted/1065327c06857f958b6ba8926f0ac9269f4f71ad07db9a879cc9f8e2f45f5255.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';
import Tooltip from '../Tooltip/303de8f785b9987afea88aa6b28176d2cc278b105d33ed5d93d1cf139ee9589d.cfe-internal.js';

var _excluded = ["buttonPosition", "onMouseMove", "onKeyDown", "value", "aria-label", "aria-labelledby", "aria-describedby", "aria-valuemin", "aria-valuemax", "aria-valuenow"];
var buttonOffset = -10;
var SliderButton = function SliderButton(_ref) {
  var _context;
  var _ref$buttonPosition = _ref.buttonPosition,
    buttonPosition = _ref$buttonPosition === void 0 ? 0 : _ref$buttonPosition,
    onMouseMove = _ref.onMouseMove,
    onKeyDown = _ref.onKeyDown,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '0' : _ref$value,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    ariaValueMin = _ref['aria-valuemin'],
    ariaValueMax = _ref['aria-valuemax'],
    ariaValueNow = _ref['aria-valuenow'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMounted = useMounted();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var handleMouseDown = function handleMouseDown(e) {
    if (e.button === 0) {
      setIsDragging(true);
    }
  };
  var handleMouseUp = function handleMouseUp(e) {
    if (isMounted.current && e.button === 0) {
      setIsDragging(false);
    }
  };

  // Update value when mouse moves
  var handleMouseMove = function handleMouseMove(e) {
    if (isMounted.current && typeof onMouseMove === 'function') {
      onMouseMove(e);
    }
  };

  // Add/remove mouse handlers when dragging starts/stops
  var options = {
    isDisabled: !isDragging
  };
  useEventListener(window, 'mousemove', handleMouseMove, options);
  useEventListener(window, 'mouseup', handleMouseUp, options);
  var anchorButton = /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    className: styles.button,
    style: {
      left: _concatInstanceProperty(_context = "calc(".concat(buttonPosition, "% + ")).call(_context, buttonOffset, "px")
    },
    onMouseDown: handleMouseDown,
    onKeyDown: onKeyDown,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    "aria-valuemin": ariaValueMin,
    "aria-valuemax": ariaValueMax,
    "aria-valuenow": ariaValueNow,
    "aria-valuetext": value,
    role: "slider",
    tabIndex: 0
  }));
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTooltip = _useState4[0],
    setShowTooltip = _useState4[1];
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    show: showTooltip,
    onShowChange: function onShowChange(shouldShowTooltip) {
      return setShowTooltip(isDragging || shouldShowTooltip);
    }
    // forces rerender of popper on button position change
    ,
    unstable_contentKey: String(buttonPosition),
    placement: "bottom",
    content: value
  }, anchorButton);
};

export { SliderButton as default };
